import useToggle from "../../hooks/useToggle";

import { use } from "react";
import BikeSelectBottomSheet from "../../components/BikeSelectBottomSheet";
import Icon from "../../components/Icon";
import KeyboardArrowDown from "../../components/icons/keyboard_arrow_down.svg?react";
import { BikeContext } from "../../context/bikeContext";
import styles from "./BikeSelect.module.css";

const BikeSelect = () => {
  const { bike } = use(BikeContext);
  const bikeSelectDialog = useToggle();

  return (
    <>
      <button className={styles.title} onClick={bikeSelectDialog.open}>
        {bike?.name}
        <Icon className={styles.icon} glyph={KeyboardArrowDown} />
      </button>
      <BikeSelectBottomSheet
        isOpen={bikeSelectDialog.isOpen}
        onClose={bikeSelectDialog.close}
      />
    </>
  );
};

export default BikeSelect;
